// This is a wrapper component on top of chakraUI button but used in primary login button style

import { Button, ButtonProps } from "@chakra-ui/react";

interface SecondaryLoginButton extends ButtonProps {
  isLoading?: boolean;
  onClick?: () => void;
}
export const SecondaryLoginButton = (props: SecondaryLoginButton) => {
  return (
    <Button
      {...props}
      type="button"
      variant="outline"
      size="lg"
      w="full"
      onClick={props.onClick}
      loading={props.isLoading}
      loadingText="Signing in..."
      borderColor="gray.300"
      _hover={{ bg: "gray.50", borderColor: "gray.400" }}
    />
  );
};
